import { createSlice } from "@reduxjs/toolkit";
import { verifyDocument , getDocument} from "./VerifyAction";

const verifySlice = createSlice({
  name: "Verify",
  initialState: {
    verifyLoading: false,
    verifyError: false,
    verify: {},
    verifySuccess: false,
    document: {},
    documentSuccess: false,
    documentError: false,
    documentLoading: false
  },
  reducers: {
    clearError: (state) => {
      state.verifyError = false;
    },
    clearVerify: (state) => {
      state.verify = {};
    },
    clearVerifySuccess: (state) => {
      state.verifySuccess = false;
    },
    clearGetDocumentError: (state) => {
      state.documentError = false;
    },
    clearGetDocumentSuccess: (state) => {
      state.documentSuccess = false;
    },
    clearGetDocumentLoading: (state) => {
      state.documentLoading = false;
    },
    clearGetDocument: (state) => {
      state.document = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyDocument.pending, (state) => {
        state.verifyLoading = true;
      })
      .addCase(verifyDocument.fulfilled, (state, action) => {
        state.verify = action.payload?.details;;
        state.verifySuccess = true;
        state.verifyLoading = false;
        state.verifyError = false;
      })
      .addCase(verifyDocument.rejected, (state, action) => {
        state.verifyLoading = false;
        state.verifyError = true;
      })
      .addCase(getDocument.pending, (state) => {
        state.documentLoading = true;
      })
      .addCase(getDocument.fulfilled, (state, action) => {
        state.document = action.payload?.details;
        state.documentSuccess = true;
        state.documentLoading = false;
        state.documentError = false;
      })
      .addCase(getDocument.rejected, (state, action) => {
        state.documentLoading = false;
        state.documentError = true;
      });
  },
});

const verifyAction = verifySlice.actions;


export { verifyAction, verifySlice };
